export default "__VITE_ASSET__BtU_6eNa__"